import React from 'react'
import styled from 'styled-components'
import { OptionItem } from '../common'

type PullDownPickerProps = {
  options: OptionItem<number>[]
  selectedValue: number
  handleValueChanged: (option: OptionItem<number>) => void
  onClick?: () => void
  isSelected?: boolean
  className?: string
}

const PullDownPicker: React.FC<PullDownPickerProps> = ({
  options,
  selectedValue,
  handleValueChanged,
  className,
}) => {
  return (
    <TimeOptionWrap className={className}>
      {options.map((option) => (
        <TimeOption
          key={option.value}
          data-year-value={option.value}
          onClick={(): void => handleValueChanged(option)}
          isSelected={option.value === selectedValue}
        >
          {option.label || option.value}
        </TimeOption>
      ))}
    </TimeOptionWrap>
  )
}

const TimeOptionWrap = styled.ul`
  position: absolute;
  top: 20px;
  z-index: 1;
  display: flex;
  flex-direction: column;
  line-height: 25px;
  max-height: 130px;
  overflow-y: scroll;
  border: #707070 1px solid;
  padding: 4px;
  background-color: #fff;
`
const TimeOption = styled.li<{ isSelected: boolean }>`
  padding: 2px 4px;
  background-color: ${({ isSelected }): string =>
    isSelected ? '#f1f1f1' : '#fff'};
  text-align: center;
  list-style: none;
`

export default React.memo(PullDownPicker)
